import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"IBM_Plex_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-ibm-plex-sans\"}],\"variableName\":\"ibmPlexSans\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"IBM_Plex_Mono\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"500\",\"600\"],\"variable\":\"--font-ibm-plex-mono\"}],\"variableName\":\"ibmPlexMono\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AutoSyncManager"] */ "/app/src/components/network/auto-sync-manager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NetworkStatusManager"] */ "/app/src/components/network/network-status-indicator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/src/components/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PWAInstallBanner"] */ "/app/src/components/pwa/install-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerManager"] */ "/app/src/components/pwa/service-worker-manager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeScript"] */ "/app/src/lib/theme/ThemeProvider.tsx");
